(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
      
document.querySelectorAll('[id^="shopify-section-"]').forEach((card, index) => {
   console.log = function(){};
   if(card.classList.contains('featured-blog')) {     
    const topHeading = card.querySelectorAll('.for-arrow-alignment');        
    const cardHeight = parseInt(topHeading[0].clientHeight);
    const topValue = cardHeight / 2 + 5;
    const cardTopCSS = "calc(50% - "+topValue+'px)';     
    const swiperContainer = card.querySelector('.swiper');    
     if(!swiperContainer) return;
    const swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');    
    const swiperNextElement = swiperContainer.querySelector('.swiper-button-next');     
    if(!swiperPrevElement || !swiperNextElement) return
    swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);    
    swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
  }        
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);
        
        
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));     
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);



  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;

            /* ── Re-init wishlist & qty after fetch ── */
            initPrQty(this);

            /* ── Underline ── */
            prSetUnderline(this);

            /* ── Swiper navigation position ── */
            const sameCard = this.querySelector('.from-recommended');
            if (sameCard) {
              const cardHeight = parseInt(sameCard.clientHeight);
              const topValue   = cardHeight / 2 + 5;
              const cardTopCSS = 'calc(50% - ' + topValue + 'px)';
              const swiperContainer = this.querySelector('.swiper');
              if (swiperContainer) {
                const prev = swiperContainer.querySelector('.swiper-button-prev');
                const next = swiperContainer.querySelector('.swiper-button-next');
                if (prev) prev.setAttribute('style', 'top:' + cardTopCSS);
                if (next) next.setAttribute('style', 'top:' + cardTopCSS);
              }
            }
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => console.error(e));
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/* ============================================================
   prSetUnderline — measures to midpoint of "A" in word[2]
   Key fix: text is uppercased before canvas measurement
   because CSS text-transform doesn't affect canvas rendering
   ============================================================ */
function prSetUnderline(scope) {
  var el = scope.querySelector('.pr-heading');
  if (!el) return;

  var underline = el.querySelector('.pr-underline');
  if (!underline) return;

  var cs           = window.getComputedStyle(el);
  var fontWeight   = cs.fontWeight  || '700';
  var fontSize     = cs.fontSize    || '28px';
  var fontFamily   = cs.fontFamily  || 'Rubik, sans-serif';
  var letterSpacing = parseFloat(cs.letterSpacing) || 0;

  var canvas = document.createElement('canvas');
  var ctx    = canvas.getContext('2d');
  ctx.font   = fontWeight + ' ' + fontSize + ' ' + fontFamily;

  var rawText = '';
  for (var i = 0; i < el.childNodes.length; i++) {
    if (el.childNodes[i].nodeType === 3) {
      rawText += el.childNodes[i].textContent;
    }
  }

  rawText = rawText.trim().toUpperCase();

  function measureStr(str) {
    var w = 0;
    for (var j = 0; j < str.length; j++) {
      w += ctx.measureText(str[j]).width + letterSpacing;
    }
    return w;
  }

  var totalWidth = measureStr(rawText);
  
  var ratio = 0.50;
  
  var finalWidth = totalWidth * ratio;

  if (finalWidth > 0) {
    underline.style.setProperty('width', finalWidth + 'px', 'important');
  }
}

/* ── Qty Stepper ── */
function initPrQty(scope) {
  scope = scope || document;
  scope.querySelectorAll('.pr-quick-add-overlay').forEach(function(overlay) {
    var btnMinus  = overlay.querySelector('.pr-qty__btn--minus');
    var btnPlus   = overlay.querySelector('.pr-qty__btn--plus');
    var display   = overlay.querySelector('.pr-qty__display');
    var qtyHidden = overlay.querySelector('.pr-qty-sync');
    if (!btnMinus || !btnPlus || !display || !qtyHidden) return;

    var qty = 1;

    function update() {
      display.textContent = qty;
      qtyHidden.value = qty;
    }

    btnMinus.addEventListener('click', function() {
      if (qty > 1) { qty--; update(); }
    });

    btnPlus.addEventListener('click', function() {
      qty++; update();
    });
  });
}

/* ── Init on page load (for non-fetched renders) ── */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initPrQty();
    document.fonts.ready.then(function() {
      document.querySelectorAll('product-recommendations').forEach(function(scope) {
        prSetUnderline(scope);
      });
    });
  });
} else {
  initPrQty();
  document.fonts.ready.then(function() {
    document.querySelectorAll('product-recommendations').forEach(function(scope) {
      prSetUnderline(scope);
    });
  });
}


  } catch(e) { console.error(e); }
})();
})();
